import React, { Component } from 'react'
import { dropDownData, platformString } from '../../utils/drop-down'
import { getDownloadUrlByOsVersion } from '../../utils/redirect'
import { osName, getUA, isIOS, isAndroid, isChrome, isEdge, isOpera } from 'react-device-detect'
import upArrowImg from '../../assets/images/up-chevron-white.svg'
import downArrowImg from '../../assets/images/down-chevron-white.svg'
import android from '../../assets/images/android.webp'
import windows from '../../assets/images/windows.webp'
import ios from '../../assets/images/ios.webp'
import amazon from '../../assets/images/amazon.webp'
import linux from '../../assets/images/linux.webp'

class DropDownButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      output: '',
      platformsString: '',
      platform: '',
      up_down: false,
      clickedOutside: false,
      upImage: '',
      downImage: '',
    }
  }

  componentDidMount() {
    // let isClient = typeof window !== 'undefined'
    // let { page } = this.props
    // let userAgent = window.navigator.userAgent

    
    if (isIOS || getUA.includes('iPad')) {
      this.setState({ output: dropDownData.ios_main })
      this.setState({
        platformsString: platformString.ios,
      })
      this.setState({ platform: 'ios' })
    } else if (osName === 'Windows') {
      if(isChrome || isEdge || isOpera) {
        navigator.userAgentData.getHighEntropyValues(["platformVersion"])
        .then(ua => {
          if (navigator.userAgentData.platform === "Windows") {
          const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
          if (majorPlatformVersion >= 13) {
              this.setState({ 
                output: dropDownData.windows_11_main,
                platformsString: platformString.windows_11,
                platform: 'win-11'
              })
            }
            else if (majorPlatformVersion > 0) {
              this.setState({ 
                output: dropDownData.windows_9_10_main ,
                platformsString: platformString.windows_9_10,
                platform: 'win-11' 
              })
            }
            else {
              this.setState({ 
                output: dropDownData.windows_9_10_main ,
                platformsString: platformString.windows_9_10,
                platform: 'win' 
              })
            }
          }          
        })
      } else {
        this.setState({ 
          output: dropDownData.windows_9_10_main_others ,
          platformsString: platformString.windows_9_10_main_others,
          platform: 'win-others' 
        })
      }
    } else if (isAndroid) {
      this.setState({ output: dropDownData.android})
      this.setState({
        platformsString: platformString.android,
      })
      this.setState({ platform: 'android' })
    } else if (osName === 'Mac OS') {
      this.setState({ output: dropDownData.mac_main })
      this.setState({
        platformsString: platformString.mac,
      })
      this.setState({ platform: 'mac' })
    } else if (getUA.includes('Silk')) {
      this.setState({ output: dropDownData.amazon })
      this.setState({
        platformsString: platformString.amazon,
      })
      this.setState({ platform: 'amazon' })
    }
    else if (getUA.includes('Linux')) {
      this.setState({ output: dropDownData.linux_snap })
      this.setState({
        platformsString: platformString.linux_snap,
      })
      this.setState({ platform: 'linux' })
    }
    else {
      this.setState({ output: dropDownData.android })
      this.setState({
        platformsString: platformString.android,
      })
      this.setState({ platform: 'android' })
    }
    
    document.addEventListener('mousedown', this.handleClickOutside, {passive: true})

    this.setState({
      upImage: (
        <img
          style={{ height: '16px', marginBottom: '2px' }}
          src={upArrowImg}
          alt="down-up"
        />
      ),
    })
    this.setState({
      downImage: (
        <img
          style={{
            height: '16px'
          }}
          src={downArrowImg}
          alt="down-up"
        />
      ),
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = e => {
    if (this.myRef && !this.myRef.current.contains(e.target)) {
      this.setState(state => {
        return {
          open: false,
        }
      })
      this.setState({ up_down: false })
    }
  }

  myRef = React.createRef()

  handleClickInside = (e) => {
    this.setState(state => {
      return {
        open: !state.open,
      }
    })
    this.setState({ up_down: !this.state.up_down })
  }

  

  render() { 
    
    const url = typeof window !== 'undefined' ? window.location.pathname : '';
    let {
      output,
      // platformsString,
      platform,
      up_down,
      upImage,
      downImage,
    } = this.state
    return (
      <div className="platform-output-container">
        <div
          style={{
            position: 'relative',
            // margin: 'auto',
            marginTop: '20px',
            maxWidth: '352.4px'
          }}
          ref={this.myRef}
        >
          {output && (
            <div className="platform-button-main">
              {output}
              <button
                className={
                  up_down
                    ? 'arrow-drop-down-btn_open'
                    : 'arrow-drop-down-btn_close'
                }
                onClick={this.handleClickInside}
              >
                {up_down ? upImage : downImage}
              </button>
            </div>
          )}
          <div style={{ height: '0' }}>
            {this.state.open && (
              <div className="dropdownh">
                <ul className="ul-op-drop">
                  {platform !== 'mac' && (
                    <div>
                      <li className="mac-data">{dropDownData.mac}</li>
                      <hr />
                    </div>
                  )}
                  {platform !== 'ios' && (
                    <div>
                      <li>{dropDownData.ios}</li>
                      <hr />
                    </div>
                  )}
                  {platform !== 'android' && (
                    <div>
                      <li>{dropDownData.android}</li>
                      <hr />
                    </div>
                  )}
                    {
                  <div>
                    <li>{dropDownData.huawei}</li>
                    <hr />
                  </div>
                }
                  {/* {platform !== 'amazon' && (
                    <div>
                      <li>{dropDownData.amazon}</li>
                      <hr />
                    </div>
                  )} */}
         
                  {platform !== 'win-11' && platform !== 'win-others' && (
                    <div>
                      <li>{dropDownData.windows_11}</li>
                      <hr />
                    </div>
                  )}
                  {platform !== 'win' && platform !=='win-others' && (
                    <div>
                      <li>{dropDownData.windows_9_10}</li>
                      <hr />
                    </div>
                  )}
                  {
                    <div>
                      <li>{dropDownData.windows_7_8}</li>
                      <hr />
                    </div>
                  }
                  {
                  <div>
                    <li>{dropDownData.linux_deb}</li>
                    <hr />
                  </div>
                }
                  {
                  <div>
                    <li>{dropDownData.linux_prm}</li>
                    <hr />
                  </div>
                }
                  {platform !== 'linux' && <div><li>{dropDownData.linux_snap}</li></div>}
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* {platformsString} */}
        {(url !== '/') && 
          <div className="platform-string-wrapper">
              <a href={
                      osName === 'Windows'
                          ? getDownloadUrlByOsVersion()
                          : 'https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=dl'
                      } target="_blank" rel="noreferrer">
                        <img id="windows" src={windows} alt="windows" style={{width: '35px', height: '35px'}} />
              </a>
              <a href={isIOS ? 'https://apps.apple.com/us/app/bluemail/id1458754578?mt=12' : 
                        'https://apps.apple.com/us/app/blue-mail-email-mailbox/id1063729305'} 
                        target="_blank" rel="noreferrer">
                <img id="ios" src={ios} alt="ios" style={{width: '28px', height: '35px'}} />
              </a>
              <a href='https://play.google.com/store/apps/details?id=me.bluemail.mail' 
                target="_blank" rel="noreferrer">
                <img id="android" src={android} alt="android" style={{width: '34px', height: '34px'}} />
              </a>
              <a href="https://snapcraft.io/bluemail" 
              target="_blank" rel="noreferrer">
                <img id="linux" src={linux} alt="linux" style={{width: '30px', height: '39px'}} />
              </a>
              <a href="https://www.amazon.com/BlueMail-Inc/dp/B01DUUITZO" 
              target="_blank" rel="noreferrer">
                <img id="amazon" src={amazon} alt="amazon" style={{width: '63px', height: '19px'}} />
              </a>
          </div>
        }
        {(url == '/') && 
          <div style={{textAlign: "center", maxWidth: "300px", fontSize: "14px", marginTop: "12px", opacity: "0.9"}}>
            Unlimited accounts. Any provider.
          </div>
        }
      </div>
    )
  }
}

export default DropDownButton
